import React from 'react'

// Component to show stuff like 2/10 (2 items from total 10)
export default function SomeFromAll({ amount }: { amount: [number, number] }): JSX.Element {
  return (
    <div className="some-from-all">
      <span className="some">{amount[0]}</span>
      <span className="slash">/</span>
      <span className="all">{amount[1]}</span>
    </div>
  )
}
